"use strict";
/** @module BryxApi.SupportApi */
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("../../models");
var scuEvent_1 = require("../../models/scuEvent");
var cerealParse_1 = require("../../cerealParse");
var SCUMixin = /** @class */ (function () {
    function SCUMixin() {
    }
    SCUMixin.prototype.getSCUs = function (query, callback) {
        var _this = this;
        var urlParams = { query: query };
        var wrappedCallback = function (request, response) {
            callback(_this.apiArrayResultFromParse(response, models_1.SearchSCU.parse, 'warn'));
        };
        this.http.get('/scus', urlParams, this.unauthenticatedCallback(wrappedCallback));
    };
    SCUMixin.prototype.getSCU = function (id, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.LongSCU.parse));
        };
        this.http.get("/scus/" + id, null, this.unauthenticatedCallback(wrappedCallback));
    };
    SCUMixin.prototype.getNewSCUSerial = function (lowest, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiStringResult(response));
        };
        this.http.get('/scus/next-serial', { lowest: lowest ? 'true' : 'false' }, this.unauthenticatedCallback(wrappedCallback));
    };
    SCUMixin.prototype.createSCU = function (name, serial, model, ipAddress, macAddress, email, password, stationId, callback) {
        var _this = this;
        var body = {
            name: name,
            serial: serial,
            model: models_1.SCUModelEnum[model],
            ipAddress: ipAddress,
            macAddress: macAddress,
            stationId: stationId,
            email: email,
            password: password,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.SearchSCU.parse));
        };
        this.http.post('/scus', null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    SCUMixin.prototype.editSCU = function (scuId, name, serial, ipAddress, macAddress, model, email, callback) {
        var _this = this;
        var body = {
            name: models_1.FieldUtils.getEditableParam(name),
            serial: models_1.FieldUtils.getEditableParam(serial),
            ipAddress: models_1.FieldUtils.getEditableParam(ipAddress),
            macAddress: models_1.FieldUtils.getEditableParam(macAddress),
            model: models_1.FieldUtils.getEditableParam(model, function (value) { return models_1.SCUModelEnum[value]; }),
            email: models_1.FieldUtils.getEditableParam(email),
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/scus/" + scuId, null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    SCUMixin.prototype.editSCUTimes = function (scuId, shippedTs, deliveredTs, installedTs, callback) {
        var _this = this;
        var body = {
            shippedTs: models_1.FieldUtils.getClearableParam(shippedTs, -1, function (value) { return Math.floor(value.getTime() / 1000); }),
            deliveredTs: models_1.FieldUtils.getClearableParam(deliveredTs, -1, function (value) { return Math.floor(value.getTime() / 1000); }),
            installedTs: models_1.FieldUtils.getClearableParam(installedTs, -1, function (value) { return Math.floor(value.getTime() / 1000); }),
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/scus/" + scuId, null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    SCUMixin.prototype.setSCUPassword = function (scuId, password, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/scus/" + scuId, null, { password: password }, this.unauthenticatedCallback(wrappedCallback));
    };
    SCUMixin.prototype.resetSCU = function (scuId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.post("/scus/" + scuId + "/reset", null, null, this.unauthenticatedCallback(wrappedCallback));
    };
    SCUMixin.prototype.addSCUToAgency = function (scuId, agencyId, canManage, addToAllUnits, callback) {
        var _this = this;
        var body = {
            agencyId: agencyId,
            canManage: canManage,
            addToAllUnits: addToAllUnits,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.post("/scus/" + scuId + "/agencies", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    SCUMixin.prototype.removeSCUFromAgency = function (scuId, agencyId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/scus/" + scuId + "/agencies/" + agencyId, null, this.unauthenticatedCallback(wrappedCallback));
    };
    SCUMixin.prototype.addSCUToUnit = function (scuId, unitId, callback) {
        var _this = this;
        var body = {
            unitId: unitId,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.post("/scus/" + scuId + "/units", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    SCUMixin.prototype.removeSCUFromUnit = function (scuId, unitId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/scus/" + scuId + "/units/" + unitId, null, this.unauthenticatedCallback(wrappedCallback));
    };
    SCUMixin.prototype.importSCUConfig = function (scuId, configString, callback) {
        var _this = this;
        // TODO: This should be included in bryx-../../spoonClient but it does not support raw strings currently
        var request = new XMLHttpRequest();
        request.onreadystatechange = function () {
            if (request.readyState == request.DONE) {
                if (request.status == 204) {
                    try {
                        callback(_this.apiSuccess(null));
                    }
                    catch (_a) {
                        callback(_this.apiFailure('Invalid response'));
                    }
                }
                else {
                    callback(_this.apiFailure("Invalid response (" + request.status + "): " + request.responseText));
                }
            }
        };
        request.open('PUT', this.apiRoot + "/scus/" + scuId + "/server-config");
        var apiKey = this.local.apiKey;
        if (apiKey != null) {
            request.setRequestHeader('X-API-KEY', apiKey);
        }
        request.send(configString);
    };
    SCUMixin.prototype.exportSCUConfig = function (scuId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiStringResult(response));
        };
        this.http.get("/scus/" + scuId + "/server-config", null, this.unauthenticatedCallback(wrappedCallback));
    };
    SCUMixin.prototype.linkSCUToStation = function (scuId, stationId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/scus/" + scuId, null, { stationId: stationId }, this.unauthenticatedCallback(wrappedCallback));
    };
    SCUMixin.prototype.getSCUHealth = function (scuId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.SCUHealth.parse));
        };
        this.http.get("/scus/" + scuId + "/health", null, this.unauthenticatedCallback(wrappedCallback));
    };
    SCUMixin.prototype.getSCUConfig = function (scuId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.SCUConfig.parse));
        };
        this.http.get("/scus/" + scuId + "/config", null, this.unauthenticatedCallback(wrappedCallback));
    };
    SCUMixin.prototype.editSCUDaySettings = function (scuId, dayStart, dayEnd, callback) {
        var _this = this;
        var body = {
            dayStart: dayStart,
            dayEnd: dayEnd,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/scus/" + scuId + "/config", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    SCUMixin.prototype.editSCUGeneralSettings = function (scuId, lightTimeout, pollingInterval, dayTurnoutTime, nightTurnoutTime, awsRegion, alertNewAssignments, alertLateAssignments, speakNewAssignments, lightRamp, sendNetworkReminders, unitWaitTime, callback) {
        var _this = this;
        var body = {
            lightTimeout: lightTimeout,
            pollingInterval: pollingInterval,
            dayTurnoutTime: dayTurnoutTime,
            nightTurnoutTime: nightTurnoutTime,
            awsRegion: awsRegion != null ? models_1.SCUAWSRegion[awsRegion] : null,
            alertNewAssignments: alertNewAssignments,
            alertLateAssignments: alertLateAssignments,
            speakNewAssignments: speakNewAssignments,
            lightRamp: lightRamp,
            sendNetworkReminders: sendNetworkReminders,
            unitWaitTime: unitWaitTime,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/scus/" + scuId + "/config", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    SCUMixin.prototype.editSCUAudioSettings = function (scuId, systemVolume, toneVolume, dayRamp, nightRamp, resetBehavior, callback) {
        var _this = this;
        var body = {
            systemVolume: systemVolume,
            toneVolume: toneVolume,
            dayRamp: dayRamp != null ? models_1.SCURampLength[dayRamp] : null,
            nightRamp: nightRamp != null ? models_1.SCURampLength[nightRamp] : null,
            resetBehavior: resetBehavior
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/scus/" + scuId + "/config", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    SCUMixin.prototype.editSCUTtsSettings = function (scuId, voice, rate, repetitions, ttsVolume, lexicons, textToSpeech, waitForSpeechSynthesization, callback) {
        var _this = this;
        var body = {
            ttsVoice: voice != null ? models_1.SCUTTSVoice[voice] : null,
            rate: rate,
            repetitions: repetitions,
            ttsVolume: ttsVolume,
            lexicons: lexicons,
            textToSpeech: textToSpeech,
            waitForSpeechSynthesization: waitForSpeechSynthesization,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/scus/" + scuId + "/config", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    SCUMixin.prototype.addSCUTranslation = function (scuId, type, pattern, replaceWith, ignoreCase, callback) {
        var _this = this;
        var body = {
            pattern: pattern,
            replaceWith: replaceWith,
            ignoreCase: ignoreCase,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.SCUTranslation.parse));
        };
        this.http.post("/scus/" + scuId + "/config/translations/" + type, null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    SCUMixin.prototype.editSCUTranslation = function (scuId, type, translationId, pattern, replaceWith, callback) {
        var _this = this;
        var body = {
            pattern: pattern,
            replaceWith: replaceWith,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.SCUTranslation.parse));
        };
        this.http.put("/scus/" + scuId + "/config/translations/" + type + "/" + translationId, null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    SCUMixin.prototype.deleteSCUTranslation = function (scuId, type, translationId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/scus/" + scuId + "/config/translations/" + type + "/" + translationId, null, this.unauthenticatedCallback(wrappedCallback));
    };
    SCUMixin.prototype.createSCUZone = function (scuId, name, units, bridgeMac, callback) {
        var _this = this;
        var body = {
            name: name,
            units: units,
            audio: [],
            lights: [],
            bridgeMac: bridgeMac,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.SCUZone.parse));
        };
        this.http.post("/scus/" + scuId + "/config/zones", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    SCUMixin.prototype.editSCUZone = function (scuId, zoneId, name, units, audio, lights, audioResetBehavior, callback) {
        var _this = this;
        var body = {
            name: name,
            units: units,
            audio: audio,
            lights: lights,
            audioResetBehavior: audioResetBehavior
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.SCUZone.parse));
        };
        this.http.put("/scus/" + scuId + "/config/zones/" + zoneId, null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    SCUMixin.prototype.deleteSCUZone = function (scuId, zoneId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/scus/" + scuId + "/config/zones/" + zoneId, null, this.unauthenticatedCallback(wrappedCallback));
    };
    SCUMixin.prototype.pairStationBoard = function (code, scuId, zoneId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        var body = {
            code: code,
        };
        this.http.put("/scus/" + scuId + "/config/zones/" + zoneId + "/connect", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    SCUMixin.prototype.createSCUPrinter = function (scuId, name, units, type, copies, reportType, callback) {
        var _this = this;
        var body = {
            printer: name,
            units: units,
            type: models_1.SCUPrintType[type],
            copies: copies,
            reportType: models_1.SCUPrintReportType[reportType],
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.SCUPrinterConfig.parse));
        };
        this.http.post("/scus/" + scuId + "/config/printers/", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    SCUMixin.prototype.editSCUPrinter = function (scuId, printerId, units, type, copies, reportType, callback) {
        var _this = this;
        var body = {
            units: units,
            type: type != null ? models_1.SCUPrintType[type] : null,
            copies: copies,
            reportType: reportType != null ? models_1.SCUPrintReportType[reportType] : null,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.SCUPrinterConfig.parse));
        };
        this.http.put("/scus/" + scuId + "/config/printers/" + printerId, null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    SCUMixin.prototype.deleteSCUPrinter = function (scuId, printerId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/scus/" + scuId + "/config/printers/" + printerId, null, this.unauthenticatedCallback(wrappedCallback));
    };
    SCUMixin.prototype.createSCUAlertSetting = function (scuId, priority, match, audio, color, lightTimeout, repetitions, ttsVolume, toneVolume, lightRamp, brightness, tts, ramp, callback) {
        var _this = this;
        var body = {
            matchType: match.type,
            matchTypeCode: match.typeCode,
            matchUnit: match.unit,
            matchBox: match.box,
            matchPriority: match.priority,
            matchTimeStart: match.timeStart,
            matchTimeEnd: match.timeEnd,
            priority: priority,
            audio: audio,
            color: color,
            lightTimeout: lightTimeout,
            repetitions: repetitions,
            ttsVolume: ttsVolume,
            toneVolume: toneVolume,
            lightRamp: lightRamp,
            brightness: brightness,
            tts: tts,
            ramp: ramp != null ? models_1.SCURampLength[ramp] : null
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.SCUAlertSetting.parse));
        };
        this.http.post("/scus/" + scuId + "/config/alert-settings", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    SCUMixin.prototype.editSCUAlertSetting = function (scuId, settingId, priority, matchType, matchTypeCode, matchUnit, matchTimeStart, matchTimeEnd, audio, color, lightTimeout, repetitions, ttsVolume, toneVolume, lightRamp, brightness, tts, ramp, //SCURampLength, but enums suck here
    callback) {
        var _this = this;
        var body = {
            matchType: matchType,
            matchTypeCode: matchTypeCode,
            matchUnit: matchUnit,
            matchBox: null,
            matchPriority: null,
            matchTimeStart: matchTimeStart,
            matchTimeEnd: matchTimeEnd,
            priority: priority,
            audio: audio,
            color: color,
            lightTimeout: lightTimeout,
            repetitions: repetitions,
            ttsVolume: ttsVolume,
            toneVolume: toneVolume,
            lightRamp: lightRamp,
            brightness: brightness,
            tts: tts,
            ramp: ramp,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.SCUAlertSetting.parse));
        };
        this.http.put("/scus/" + scuId + "/config/alert-settings/" + settingId, null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    SCUMixin.prototype.deleteSCUAlertSetting = function (scuId, settingId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/scus/" + scuId + "/config/alert-settings/" + settingId, null, this.unauthenticatedCallback(wrappedCallback));
    };
    SCUMixin.prototype.createSCURule = function (scuId, name, enabled, timeout, ruleOn, ruleDo, ruleFinally, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.SCURule.parse));
        };
        var body = {
            name: name,
            timeout: timeout,
            enabled: enabled,
            on: ruleOn.toJson(),
            do: ruleDo.toJson(),
            finally: ruleFinally ? ruleFinally.toJson() : null,
        };
        this.http.post("/scus/" + scuId + "/config/rules", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    SCUMixin.prototype.editSCURule = function (scuId, ruleId, name, enabled, timeout, ruleOn, ruleDo, ruleFinally, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.SCURule.parse));
        };
        var body = {
            name: name,
            enabled: enabled,
            timeout: timeout,
            on: ruleOn ? ruleOn.toJson() : null,
            do: ruleDo ? ruleDo.toJson() : null,
            finally: ruleFinally ? ruleFinally.toJson() : null,
        };
        this.http.put("/scus/" + scuId + "/config/rules/" + ruleId, null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    SCUMixin.prototype.deleteSCURule = function (scuId, ruleId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/scus/" + scuId + "/config/rules/" + ruleId, null, this.unauthenticatedCallback(wrappedCallback));
    };
    SCUMixin.prototype.getScuEvents = function (scuId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiArrayResultFromParse(response, scuEvent_1.SCUEvent.parse, 'warn'));
        };
        this.http.get("/scus/" + scuId + "/events", null, this.unauthenticatedCallback(wrappedCallback));
    };
    SCUMixin.prototype.createZoneSCUAlertSetting = function (scuId, zoneId, priority, match, audio, color, lightTimeout, repetitions, ttsVolume, toneVolume, lightRamp, brightness, tts, ramp, callback) {
        var _this = this;
        var body = {
            matchType: match.type,
            matchTypeCode: match.typeCode,
            matchUnit: match.unit,
            matchBox: match.box,
            matchPriority: match.priority,
            matchTimeStart: match.timeStart,
            matchTimeEnd: match.timeEnd,
            priority: priority,
            audio: audio,
            color: color,
            lightTimeout: lightTimeout,
            repetitions: repetitions,
            ttsVolume: ttsVolume,
            toneVolume: toneVolume,
            lightRamp: lightRamp,
            brightness: brightness,
            tts: tts,
            ramp: ramp != null ? models_1.SCURampLength[ramp] : null,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.SCUAlertSetting.parse));
        };
        this.http.post("/scus/" + scuId + "/config/zones/" + zoneId + "/alert-settings", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    SCUMixin.prototype.editZoneSCUAlertSetting = function (scuId, zoneId, settingId, priority, matchType, matchTypeCode, matchUnit, matchTimeStart, matchTimeEnd, audio, color, lightTimeout, repetitions, ttsVolume, toneVolume, lightRamp, brightness, tts, ramp, callback) {
        var _this = this;
        var body = {
            matchType: matchType,
            matchTypeCode: matchTypeCode,
            matchUnit: matchUnit,
            matchBox: null,
            matchPriority: null,
            matchTimeStart: matchTimeStart,
            matchTimeEnd: matchTimeEnd,
            priority: priority,
            audio: audio,
            color: color,
            lightTimeout: lightTimeout,
            repetitions: repetitions,
            ttsVolume: ttsVolume,
            toneVolume: toneVolume,
            lightRamp: lightRamp,
            brightness: brightness,
            tts: tts,
            ramp: ramp,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.SCUAlertSetting.parse));
        };
        this.http.put("/scus/" + scuId + "/config/zones/" + zoneId + "/alert-settings/" + settingId, null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    SCUMixin.prototype.deleteZoneSCUAlertSetting = function (scuId, zoneId, settingId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/scus/" + scuId + "/config/zones/" + zoneId + "/alert-settings/" + settingId, null, this.unauthenticatedCallback(wrappedCallback));
    };
    SCUMixin.prototype.pushScuConfig = function (scuId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, function (o) {
                try {
                    return cerealParse_1.ParseUtils.parseSuccess(cerealParse_1.ParseUtils.getString(o, 'response'));
                }
                catch (e) {
                    return cerealParse_1.ParseUtils.parseFailure('Failed to load response');
                }
            }));
        };
        this.http.post("/scus/" + scuId + "/push-config", null, null, this.unauthenticatedCallback(wrappedCallback));
    };
    return SCUMixin;
}());
exports.default = SCUMixin;
//# sourceMappingURL=SCUMixin.js.map